import Reveal from "@/components/Reveal";
import { JOURNAL } from "@/constants/testIds";
import { ASSETS } from "@/lib/config";

const posts = [
  {
    category: "Mindset",
    title: "On protecting your peace in a loud world",
    date: "Coming Soon",
    img: ASSETS.joshuaTree,
  },
  {
    category: "Faith",
    title: "Anchors — a note on belief and slow mornings",
    date: "Coming Soon",
    img: ASSETS.skyClouds,
  },
  {
    category: "Travel",
    title: "Capri, from above: notes from a slower summer",
    date: "Coming Soon",
    img: ASSETS.capri,
  },
  {
    category: "Wellness",
    title: "The ritual of a walk without a phone",
    date: "Coming Soon",
    img: ASSETS.climbing,
  },
];

export default function Journal() {
  return (
    <section
      id="journal"
      data-testid={JOURNAL.root}
      className="relative text-[#e8ecef] py-32 md:py-48"
      style={{
        backgroundImage:
          "linear-gradient(to bottom, #142e25 0%, #0f1216 18%, #0f1216 82%, #0a0e14 100%)",
      }}
    >
      <div className="max-w-[1500px] mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-10 mb-20 md:mb-28">
          <div>
            <Reveal>
              <p className="text-[11px] tracking-[0.38em] uppercase text-[#8a9498] mb-8">
                (04) — The Journal
              </p>
            </Reveal>
            <Reveal delay={0.05}>
              <h2 className="font-serif text-5xl md:text-6xl lg:text-7xl leading-[1.02] tracking-tight">
                Words for the<br />
                <span className="font-light text-[#8a9498]">
                  quiet hours.
                </span>
              </h2>
            </Reveal>
          </div>
          <Reveal delay={0.1}>
            <p className="text-[#8a9498] max-w-sm font-light leading-relaxed">
              Field notes on mindset, faith, travel, and the practice of a life
              lived with attention.
            </p>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-20">
          {posts.map((post, i) => (
            <Reveal
              key={post.title}
              delay={i * 0.06}
              className={i % 2 === 1 ? "md:mt-20" : ""}
            >
              <article
                data-testid={JOURNAL.card(i)}
                className="group cursor-not-allowed"
              >
                <div className="relative w-full aspect-square overflow-hidden bg-[#0f1216]">
                  <img
                    src={post.img}
                    alt={post.title}
                    className="w-full h-full object-cover transition-transform duration-[1400ms] group-hover:scale-[1.03]"
                    loading="lazy"
                    draggable={false}
                  />
                  {/* Blend image into section color */}
                  <div className="pointer-events-none absolute inset-x-0 bottom-0 h-2/5 bg-gradient-to-t from-[#0f1216] via-[#0f1216]/60 to-transparent" />
                  <div className="absolute top-5 left-5 flex gap-2">
                    <span className="bg-[#e8ecef]/95 backdrop-blur px-3 py-1 text-[10px] tracking-[0.28em] uppercase text-[#0a0a0a]">
                      {post.category}
                    </span>
                    <span className="bg-[#0a0a0a]/80 backdrop-blur border border-[#e8ecef]/20 text-[#e8ecef] px-3 py-1 text-[10px] tracking-[0.28em] uppercase">
                      Coming Soon
                    </span>
                  </div>
                </div>
                <h3 className="mt-8 font-serif text-2xl md:text-3xl lg:text-4xl leading-tight tracking-tight max-w-[26ch]">
                  {post.title}
                </h3>
                <p className="mt-3 text-[11px] tracking-[0.3em] uppercase text-[#8a9498]">
                  {post.date}
                </p>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
